(function () {
  'use strict';

  const MQL = window.matchMedia('(max-width: 1023.98px)');
  if (!MQL.matches) return;

  const keys = ['people', 'making', 'beginning'];

  for (const key of keys) {
    const body = document.querySelector('.p-about-cont-body[data-about-content="' + key + '"]');
    const drawer = document.querySelector('.p-page-about__drawer[data-about-drawer="' + key + '"]');
    if (!body || !drawer) continue;
    drawer.appendChild(body);
  }

  const wrapper = document.querySelector('.p-page-about__wrapper');
  const container = document.querySelector('.p-page-about__container');
  document.querySelectorAll('[data-about-toggle]').forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const key = toggle.dataset.aboutToggle;
      const drawer = document.querySelector('.p-page-about__drawer[data-about-drawer="' + key + '"]');
      if (!drawer) return;
      const isClosing = toggle.closest('.p-page-about__drawer');
      drawer.classList.toggle('is-open', !isClosing);
      wrapper.classList.toggle('has-drawer-open', !isClosing);

      if (isClosing) {
        const containerToggle = container && container.querySelector('[data-about-toggle="' + key + '"]');
        if (containerToggle) {
          const targetY = containerToggle.getBoundingClientRect().top + window.scrollY;
          //window.scrollTo({ top: targetY, behavior: 'smooth' });
          window.scrollTo({ top: 0 });
        }
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        //window.scrollTo({ top: 0 });
      }
    });
  });
})();

(function () {
  'use strict';

  if (typeof gsap === 'undefined') return;
  gsap.registerPlugin(ScrollTrigger);

  const track = document.querySelector('.p-beginning-story__image-track');
  const trackItem = track && track.querySelector('.p-beginning-story__track-item');
  if (!track || !trackItem) return;

  const MQL = window.matchMedia('(min-width: 1024px)');
  const SPEED = 60; // px/sec
  const MAX_SETS = 20; // 無限ループ防止の安全上限

  const originalItems = Array.from(trackItem.children);
  let clones = [];
  let tween;

  function appendSet() {
    originalItems.forEach((item) => {
      const clone = item.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      trackItem.appendChild(clone);
      clones.push(clone);
    });
  }

  function removeClones() {
    clones.forEach((clone) => clone.remove());
    clones = [];
  }

  function setup() {
    if (tween) tween.kill();
    gsap.set(trackItem, { x: 0 });

    if (clones.length === 0) appendSet();

    const distance = clones[0].getBoundingClientRect().left - originalItems[0].getBoundingClientRect().left;
    const requiredWidth = distance + track.clientWidth;

    let setsAdded = 1;
    while (trackItem.scrollWidth < requiredWidth && setsAdded < MAX_SETS) {
      appendSet();
      setsAdded++;
    }

    tween = gsap.to(trackItem, {
      x: -distance,
      duration: distance / SPEED,
      ease: 'none',
      repeat: -1,
    });
  }

  function teardown() {
    if (tween) {
      tween.kill();
      tween = null;
    }
    gsap.set(trackItem, { x: 0 });
    removeClones();
  }

  if (MQL.matches) setup();
  MQL.addEventListener('change', (e) => (e.matches ? setup() : teardown()));

  let resizeTimer;
  window.addEventListener('resize', () => {
    if (!MQL.matches) return;
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(setup, 200);
  });

  let mm = gsap.matchMedia();
  mm.add('(min-width: 1024px)', () => {

    const path = document.getElementById('arrow-path');
    const head = document.getElementById('arrow-head');
    const totalLen = path.getTotalLength();

    const arrowSegments = parseArrowSegments(path);
    const arrowCumLens = [];
    let arrowCumulative = 0;
    arrowSegments.forEach((segment) => {
      arrowCumulative += segment.length;
      arrowCumLens.push(arrowCumulative);
    });
    const arrowHeadOrigin = arrowSegments[arrowSegments.length - 1].to;
    const cp1 = arrowCumLens[0];
    const cp2 = arrowCumLens[2];
    const cp3 = totalLen;

    gsap.set(path, { strokeDasharray: totalLen, strokeDashoffset: totalLen });
    const arrow = { drawn: 0 };
    syncArrow();

    const c01 = document.querySelector('.p-making-card--01');
    const c02 = document.querySelector('.p-making-card--02');
    const c03 = document.querySelector('.p-making-card--03');
    const tl_01 = createObjTimeline(c01);
    tl_01.to(arrow, { drawn: cp1, onUpdate: syncArrow });
    tl_01.from(c01, { autoAlpha: 0 }, "<");
    tl_01.from(c02, { autoAlpha: 0 }, "-=0.3");
    tl_01.from(c03, { autoAlpha: 0 }, "-=0.3");

    const c04 = document.querySelector('.p-making-card--04');
    const c05 = document.querySelector('.p-making-card--05');
    const c06 = document.querySelector('.p-making-card--06');
    const tl_02 = createObjTimeline(c04);
    tl_02.to(arrow, { drawn: cp2, onUpdate: syncArrow });
    tl_02.from(c04, { autoAlpha: 0 }, "<");
    tl_02.from(c05, { autoAlpha: 0 }, "-=0.3");
    tl_02.from(c06, { autoAlpha: 0 }, "-=0.3");

    const c07 = document.querySelector('.p-making-card--07');
    const c08 = document.querySelector('.p-making-card--08');
    const tl_03 = createObjTimeline(c07);
    tl_03.to(arrow, { drawn: cp3, onUpdate: syncArrow });
    tl_03.from(c07, { autoAlpha: 0 }, "<");
    tl_03.from(c08, { autoAlpha: 0 }, "-=0.3");

    // Fade in
    gsap.utils.toArray('.js-fade-in').forEach((el) => {
      gsap.set(el, { autoAlpha: 0 });
      gsap.to(el, {
        autoAlpha: 1,
        duration: 0.8,
        ease: "sine.inOut",
        scrollTrigger: {
          trigger: el,
          start: '0% 60%',
          //once: true,
          //markers: true,
          //id: 'fade-in'
        },
      });
    });

    // Timeline
    function createObjTimeline(trigger, start = '0% 60%') {
      return gsap.timeline({
        defaults: {
          duration: 0.8,
          ease: "sine.inOut",
        },
        scrollTrigger: {
          trigger: trigger,
          start: start,
          //id: "tl-" + trigger.className,
          //markers: true
        }
      });
    }

    // Arrow path / head
    function parseArrowSegments(pathEl) {
      const commands = pathEl.getAttribute('d').match(/[MLH][^MLH]*/g) || [];
      const points = [];
      let current = { x: 0, y: 0 };
      commands.forEach((command) => {
        const type = command[0];
        const args = command.slice(1).trim().split(/[\s,]+/).filter(Boolean).map(Number);
        current = type === 'H' ? { x: args[0], y: current.y } : { x: args[0], y: args[1] };
        points.push(current);
      });

      const segments = [];
      for (let i = 1; i < points.length; i++) {
        const from = points[i - 1];
        const to = points[i];
        const dx = to.x - from.x;
        const dy = to.y - from.y;
        segments.push({
          from,
          to,
          length: Math.hypot(dx, dy),
          angle: Math.atan2(dy, dx) * (180 / Math.PI),
        });
      }
      return segments;
    }

    function getArrowState(drawn) {
      const clamped = Math.max(0, Math.min(drawn, totalLen));
      let index = arrowSegments.findIndex((segment, i) => clamped <= arrowCumLens[i]);
      if (index === -1) index = arrowSegments.length - 1;
      const segment = arrowSegments[index];
      const segStart = index === 0 ? 0 : arrowCumLens[index - 1];
      const t = segment.length === 0 ? 1 : (clamped - segStart) / segment.length;
      return {
        x: segment.from.x + (segment.to.x - segment.from.x) * t,
        y: segment.from.y + (segment.to.y - segment.from.y) * t,
        angle: segment.angle,
      };
    }

    function syncArrow() {
      path.style.strokeDashoffset = totalLen - arrow.drawn;
      const state = getArrowState(arrow.drawn);
      const dx = state.x - arrowHeadOrigin.x;
      const dy = state.y - arrowHeadOrigin.y;
      gsap.set(head, {
        attr: {
          transform: 'translate(' + dx + ' ' + dy + ') rotate(' + state.angle + ' ' + arrowHeadOrigin.x + ' ' + arrowHeadOrigin.y + ')',
        },
      });
    }
  });

  document.addEventListener('page:loaded', function() {
    console.log('page:loaded');
    ScrollTrigger.refresh();
  });
})();